import { render, staticRenderFns } from "./TipController.vue?vue&type=template&id=df069c0e&scoped=true&"
import script from "./TipController.vue?vue&type=script&lang=ts&"
export * from "./TipController.vue?vue&type=script&lang=ts&"
import style0 from "./TipController.vue?vue&type=style&index=0&id=df069c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df069c0e",
  null
  
)

export default component.exports